/*
 * Copyright (c) 2026. Amazon.com, Inc. or its affiliates. All rights reserved.
 */

import { getAuth } from '@/auth/authRef'
import { AuthStatus } from '@amzn/bf-playback'

/**
 * Routes a signed-in-only gesture to the app-wide sign-in flow when the
 * session is anonymous, returning true so the caller no-ops. Gates on
 * SIGNED_OUT only: a PENDING cold start isn't yet anonymous, and a signed-in
 * FREE customer (a tier gate, not an auth gate) never trips this.
 */
export function promptSignInIfAnonymous(): boolean {
    const auth = getAuth()
    if (auth.status.value !== AuthStatus.SIGNED_OUT) return false
    auth.signIn()
    return true
}
